function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M12.15 20q-1.625 0-2.925-.813t-2.1-2.287q-.225-.425-.05-.9t.675-.675q.425-.2.863-.025t.712.625q.45.75 1.188 1.213t1.687.462q1.05 0 1.9-.5t.85-1.6q0-.45-.175-.825T14.3 14h2.8q.125.35.188.713t.062.787q0 2.15-1.538 3.325T12.15 20ZM3 12q-.425 0-.713-.288T2 11q0-.425.288-.713T3 10h18q.425 0 .713.288T22 11q0 .425-.288.713T21 12H3Zm4.25-4q.05-1.725 1.363-2.938T12.05 3.85q1.35 0 2.425.537t1.8 1.663q.275.425.1.9t-.675.7q-.375.175-.812.038t-.788-.563q-.325-.375-.825-.625T12.1 6.25q-1.025 0-1.7.463T9.65 8h-2.4Z"
});

var SvgStrike = function SvgStrike(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStrike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/strike.97f4a961.svg";
export { ForwardRef as ReactComponent };